import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import { TravelGuide } from '../../interfaces';

@Component({
  selector: 'cms-travel-guide',
  templateUrl: './cms-travel-guide.component.html',
  styleUrls: ['cms-travel-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsTravelGuideComponent {
  private themeService = inject(FinnairThemeService);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input<TravelGuide>();

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  readonly related = computed<TravelGuide[] | undefined>(() => {
    const content = this.content();
    return content?.related ?? undefined;
  });
}
